// extracted by mini-css-extract-plugin
export default {"messageRow":"documents-tree_messageRow__tKxXS"};